<div class="modal-body">
    <div>{{prompt}}</div>
</div>
<div class="modal-footer">
    <button type="submit" class="btn btn-round" focus-me [ngClass]="okBtnClass" (click)="confirmModal()"><i class="far " *ngIf="okBtnIcon" [ngClass]="okBtnIcon"></i> {{okBtnText}}</button>
</div>